import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useSEO } from "@/hooks/use-seo";
import {
  ReviewTableOfContents, StickyReviewHeader, ProsConsHeroBlock,
  ResponsibleGamingChecklist, AuthorBylineCard, UpdateDateLine,
} from "@/components/CasinoReviewTemplate";
import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  Clock, Mail, MessageCircle, Globe, Calendar, Lock, Users, Trophy,
  Zap, AlertTriangle
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo10 from "@assets/logos_extracted/10.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://record.discasinoaffiliates.com/_kTMXKwmZsM98YAuMxhPI-WNd7ZgqdRLk/1/?pg=1";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Přes 5 000 her od těch nejlepších firem",
  "Fakt štědrý uvítací bonus",
  "10% týdenní cashback – a nemusíte nic protáčet",
  "Můžete platit kryptoměnami a výplaty jsou rychlé",
  "Pohodlná mobilní verze – nic nemusíte stahovat",
];

const cons = [
  "Nemá vlastní mobilní aplikaci",
  "Málo filtrů pro hledání her",
  "Licence z Curacaa je volnější než MGA nebo UKGC",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>500 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>625 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>1–3 dny; krypto okamžitě</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky:</span><span className={valueClass}>Žádné za vklady ani výběry</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <div className="flex flex-wrap gap-1.5">{["Visa", "Mastercard", "Google Pay", "Apple Pay", "Bitcoin", "Ethereum", "Litecoin", "Tether", "Bankovní převod"].map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <div className="flex flex-wrap gap-1.5">{["Visa", "Mastercard", "Google Pay", "Apple Pay", "Bitcoin", "Ethereum", "Litecoin", "Tether", "Bankovní převod"].map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 5 000 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Ano – klasické, Megaways, progresivní jackpoty</span></div>
        <div className={rowClass}><span className={labelClass}>Stolní hry:</span><span className={valueClass}>Ruleta, blackjack, baccarat</span></div>
        <div className={rowClass}><span className={labelClass}>Živé kasino:</span><span className={valueClass}>Ano – Evolution Gaming, Pragmatic Play Live</span></div>
        <div className={rowClass}><span className={labelClass}>Exkluzivní hry:</span><span className={valueClass}>Fu Bao Favorites</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>Evolution Gaming, NetEnt, Pragmatic Play</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>Dostupné 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano – odpověď do pár minut</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>Ano – odpověď do 24 hodin</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky podpory:</span><span className={valueClass}>Angličtina, španělština, němčina a další</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2024</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Simba N.V.</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Curacao (č. OGL/2024/1788/1030)</span></div>
        <div className={rowClass}><span className={labelClass}>Maskot:</span><span className={valueClass}>Fu Bao – panda v asijském stylu</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Mobilní web – bez nutnosti stahování</span></div>
        <div className={rowClass}><span className={labelClass}>Turnaje:</span><span className={valueClass}>Ano – prize pool až 50 000 000 Kč</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Sebeomezení vkladů:", "Ano"],
      ["Limit proher:", "Ano"],
      ["Limit herního času:", "Ano"],
      ["Sebevyloučení:", "Ano"],
      ["Ověření věku (KYC):", "Povinné"],
      ["Demo režim:", "Ano"],
    ];
    return <ResponsibleGamingChecklist items={items} />;
  }
  return null;
}

export default function GoldenPandaPage() {
  useSEO({ title: "Golden Panda Recenze 2026 – Bonus 125 000 Kč | HrajBonus", description: "Recenze Golden Panda Casino. Uvítací bonus 200 % až 125 000 Kč + 50 free spinů. Přes 4 000 her a rychlé výplaty. Hodnocení 9.0/10. 18+",
  url: "https://hrajbonus.com/kasina/golden-panda", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllPayments, setShowAllPayments] = useState(false);

  const paymentMethods = [
    "Visa", "Mastercard", "Google Pay", "Apple Pay",
    "Bitcoin", "Ethereum", "Litecoin", "Tether",
    "Bankovní převod",
  ];
  const visiblePayments = showAllPayments ? paymentMethods : paymentMethods.slice(0, 6);

  return (
    <>
      <StickyReviewHeader casinoName="Golden Panda" logoSrc={logo10} rating="8.0" ctaUrl={CASINO_URL} />
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo10} alt="Golden Panda logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Recenze Kasina Golden Panda</h1>
                    <UpdateDateLine date="15/02/2026" authorName="Mykhailo Romaenko" />
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <Star className="w-5 h-5 fill-[#f5c518]/25 text-[#f5c518]" />
                  </div>
                  <span className="text-white font-bold text-xl">8.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",        value: "5 000+" },
                    { label: "Minimální vklad",  value: "500 Kč" },
                    { label: "Minimální výběr",  value: "625 Kč" },
                    { label: "Wager",            value: "30×" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>

                <ProsConsHeroBlock pros={pros} cons={cons} />
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 125 000 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 50 Freespiny</div>
                  <div className="text-white/50 text-xs mt-1">Wager 30× (nižší než standard!)</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Golden Panda" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              <ReviewTableOfContents />

              {/* Author opinion */}
              <AuthorBylineCard name="Mykhailo Romaenko" initials="MR" photo={mykhailoPhoto} role="Senior Content Writer" score="8.0" date="15/02/2026">
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Golden Panda nabízí skvělé podmínky, hlavně pokud rádi hrajete s kryptoměnami. I když má pár drobných nedostatků, bohatě je vyvažuje bonusy a neuvěřitelnou spoustou her.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Plusy
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Mínusy
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AuthorBylineCard>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Intro */}
              <div id="prehled" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  Golden Panda Casino — Detailní pohled na platformu
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Golden Panda je online kasino, které spustilo provoz v roce 2024 a za jeho vznikem stojí společnost Simba N.V. Pyšní se licencí z Curacaa (č. OGL/2024/1788/1030) a nabízí více než 3 000 her od těch nejlepších vývojářů, jako jsou Evolution Gaming, NetEnt nebo Pragmatic Play. Celý web je laděn do asijského stylu a má dokonce roztomilého maskota – pandu jménem Fu Bao. Díky tomu působí kasino originálně a příjemně.
                </p>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                  <div className="flex items-start gap-2">
                    <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                    <p className="text-amber-700 text-sm leading-relaxed">
                      Golden Panda provozuje svou činnost na základě licence Curacao (OGL/2024/1788/1030). Tato licence je mezinárodně uznávaná, avšak volnější než MGA nebo UKGC. Z pohledu českého práva nejde o operátora s národní licencí Ministerstva financí ČR. Hrajte zodpovědně a vždy si ověřte podmínky pro svůj region.
                    </p>
                  </div>
                </div>
              </div>

              {/* Why players love it */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Proč si Golden Panda prostě zamilujete</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Novým hráčům se bude líbit jednoduché a intuitivní ovládání a možnost hrát sloty už od sázky 0,25 Kč. Zkušení borci zase ocení přístup k VIP stolům s vysokými limity a exkluzivní turnaje, kde se hraje o prize pool až 50 000 000 Kč.
                </p>

                <div className="grid sm:grid-cols-2 gap-3">
                  {[
                    { title: "Začátečníci", items: ["Jednoduchá registrace za pár minut", "Intuitivní ovládání", "Sloty od 0,25 Kč za spin", "Žádné poplatky za vklady"] },
                    { title: "Zkušení hráči", items: ["VIP stoly s vysokými limity", "Turnaje s prize poolem až 50 000 000 Kč", "Osobní manažer při VIP statusu", "Cashback bez wageringu"] },
                  ].map(({ title, items }) => (
                    <div key={title} className="bg-[#f3f6fb] rounded-xl p-4">
                      <div className="font-bold text-gray-900 text-sm mb-2">{title}</div>
                      <ul className="space-y-1">
                        {items.map(item => (
                          <li key={item} className="flex items-start gap-1.5 text-gray-600 text-xs">
                            <CheckCircle className="w-3.5 h-3.5 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              {/* Registration */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jak se do Golden Panda zaregistrovat</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Registrace v Golden Panda je hotová za pár minut a hned se vám otevře cesta k super bonusům a bleskovým výplatám. Postupujte podle těchto jednoduchých kroků a můžete začít hrát ještě dnes:
                </p>
                <div className="space-y-3 mb-4">
                  {[
                    ["Jděte na web.", "Otevřete si oficiální stránky kasina v prohlížeči, z jakéhokoli zařízení."],
                    ["Klikněte na \u201eRegistrace\u201c.", "Vpravo nahoře najděte a klikněte na tlačítko \u201eRegistrace\u201c."],
                    ["Vyplňte, co je potřeba.", "Zadejte své osobní údaje, vymyslete si heslo a vyberte měnu."],
                    ["Aktivujte si účet.", "Na váš e-mail přijde zpráva. Klikněte na odkaz v e-mailu a účet se vám aktivuje."],
                    ["Přihlaste se.", "Jděte na web, přihlaste se svým jménem a heslem. Pak jděte do pokladny, vyberte, jak chcete platit, a vložte první deposit, abyste si aktivovali uvítací bonus."],
                  ].map(([step, desc], i) => (
                    <div key={i} className="flex items-start gap-3">
                      <span className="text-[#003da5] font-black text-sm flex-shrink-0 mt-0.5">{i + 1}.</span>
                      <div>
                        <span className="font-semibold text-gray-900 text-sm">{step}</span>
                        <span className="text-gray-500 text-sm"> {desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm italic">
                  A je to! Teď jste plnohodnotným hráčem Golden Panda. Po registraci se vám zpřístupní úplně všechno, co kasino nabízí. Jen nezapomeňte si před vkladem přečíst podmínky bonusů.
                </p>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy a akce, které Golden Panda nabízí</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Golden Panda své hráče vážně odměňuje! Podívejte se, co všechno můžete získat.
                </p>

                <h3 className="font-bold text-gray-900 text-base mb-3">Uvítací bonus</h3>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-4">
                  <div className="text-[#003da5] font-black text-xl mb-1">200% bonus k prvnímu vkladu</div>
                  <div className="text-[#c9960f] font-bold text-base mb-1">až do 187 500 Kč</div>
                  <div className="text-gray-500 text-xs">Minimální vklad: 500 Kč · Wager: 30× · Platnost: 7 dní</div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Noví hráči dostanou 200% bonus k prvnímu vkladu, a to až do 187 500 Kč. Minimální vklad je 500 Kč. Bonus se uvolňuje postupně: za každých 15násobných protočení vkladu se vám aktivuje 25 % bonusu. Pro výběr je potřeba bonus protočit 60× a máte na to 7 dní.
                </p>

                <h3 className="font-bold text-gray-900 text-base mb-3">Jak si uvítací bonus vyzvednout</h3>
                <div className="space-y-2 mb-5">
                  {[
                    "Zaregistrujte se na webu.",
                    "Vložte svůj první vklad od 500 Kč.",
                    "Bonus se vám automaticky připíše na účet.",
                    "Začněte hrát a splňte požadavky na protočení, abyste si mohli peníze vybrat.",
                  ].map((step, i) => (
                    <div key={i} className="flex items-start gap-2.5 text-gray-700 text-sm">
                      <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                    </div>
                  ))}
                </div>

                {/* Cashback highlight */}
                <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-5">
                  <div className="font-bold text-green-800 text-sm mb-1">🎉 10% týdenní cashback BEZ wageringu</div>
                  <p className="text-green-700 text-sm leading-relaxed">
                    Zlatý hřeb nabídky Golden Panda: každý týden dostanete zpět 10 % ze svých ztrát – a nemusíte cashback vůbec protáčet. To je výjimečné oproti konkurenci, kde cashback téměř vždy podléhá podmínkám protočení.
                  </p>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">Bonus bez vkladu</div>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Momentálně Golden Panda nenabízí bonusy bez vkladu. Ale nebojte, i tak můžete využít spoustu jiných výhodných nabídek. Třeba můžete k uvítacímu bonusu dostat navíc 10% týdenní cashback.
                  </p>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-2">Potřebujete promo kódy?</div>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Pro získání těchto bonusů nemusíte zadávat žádné promo kódy. Všechny bonusy se aktivují automaticky, jakmile splníte podmínky.
                  </p>
                </div>

                <div className="grid sm:grid-cols-2 gap-2">
                  {["Uvítací bonus 200%", "10% týdenní cashback (bez wageru!)", "Reload bonusy", "Turnaje s prize poolem", "VIP program", "Exkluzivní akce pro VIP"].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <Trophy className="w-4 h-4 text-[#c9960f] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* VIP */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Věrnostní a VIP program</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Golden Panda má pro své hráče připravený VIP program s několika úrovněmi. Ti s vyšším statusem se mohou těšit na exkluzivní bonusy, vyšší limity na výběry a dokonce i osobního manažera.
                </p>
                <div className="grid sm:grid-cols-3 gap-2">
                  {["Exkluzivní bonusy", "Vyšší limity výběrů", "Osobní manažer"].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm bg-[#f3f6fb] rounded-lg px-3 py-2">
                      <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* UX / Design */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Vzhled a jak se vám bude hrát</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Web je navržen ve světlých barvách se zlatými a červenými detaily. Rozhraní je jednoduché a přehledné, tlačítka jsou velká a snadno čitelná, takže se tu budete cítit komfortně. Navíc je web plně přizpůsobený pro různá zařízení, včetně mobilů a tabletů.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-4">
                  <div className="font-bold text-gray-900 text-sm mb-2">Jak se pohybovat po webu</div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-2">
                    Rozhraní Golden Panda je promyšlené do posledního detailu – i nováček snadno najde, co potřebuje:
                  </p>
                  <ul className="space-y-1">
                    {[
                      "Hlavní menu najdete nahoře na obrazovce.",
                      "Hry můžete hledat pomocí zabudovaného vyhledávacího řádku.",
                      "Profil a nastavení účtu jsou vpravo nahoře.",
                      "Celý web se rychle načítá a pohyb po něm je plynulý.",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-1.5 text-gray-600 text-xs">
                        <CheckCircle className="w-3.5 h-3.5 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                  <p className="text-gray-500 text-xs mt-2 italic">Navigace je opravdu intuitivní a umožňuje vám rychle přeskakovat mezi jednotlivými sekcemi.</p>
                </div>
              </div>

              {/* Games */}
              <div id="hry" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Kasinové hry</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Golden Panda se pyšní obrovskou sbírkou více než 3 000 her od nejlepších vývojářů. V katalogu najdete:
                </p>
                <div className="space-y-2 mb-5">
                  {[
                    "Klasické sloty (včetně Megaways a progresivních jackpotů).",
                    "Stolní hry (ruleta, blackjack, baccarat).",
                    "Live kasino s opravdovými dealery.",
                    "Exkluzivní hry, jako třeba \u201eFu Bao Favorites\u201c.",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm italic">Tahle rozmanitost zaručuje, že si každý hráč najde to své a bude se bavit!</p>

                <div className="mt-5 bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Hry s živými dealery</div>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">
                    Pro ty, kdo milují pocit z opravdového kasina, nabízí Golden Panda desítky her s živými dealery od těch nejlepších studií. V sekci live kasina najdete:
                  </p>
                  <ul className="space-y-1.5">
                    {[
                      "Evolution Gaming, Pragmatic Play – naprostá špička na trhu.",
                      "Ruletu, blackjack, baccarat, herní show (třeba Crazy Time).",
                      "Možnost hrát v angličtině, španělštině, němčině a dalších jazycích.",
                      "Interaktivní chat s dealery.",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-1.5 text-gray-600 text-xs">
                        <CheckCircle className="w-3.5 h-3.5 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                  <p className="text-gray-500 text-xs mt-2 italic">Tahle sekce je přesně pro ty, kdo si cení autentické atmosféry kasina a živé komunikace.</p>
                </div>
              </div>

              {/* Mobile */}
              <div id="mobilni" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Golden Panda na mobilu</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  S mobilní verzí Golden Panda si můžete zahrát bez omezení přímo ze smartphonu nebo tabletu – a nemusíte nic stahovat! Web je perfektně optimalizován pro mobilní zařízení. Mobilní verze zaručuje plynulé hraní bez nutnosti stahování jakýchkoli aplikací.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    "Optimalizováno pro smartphone i tablet",
                    "Žádné stahování aplikací",
                    "Plynulé načítání her",
                    "Dotykové ovládání",
                    "Přístup ke všem hrám i bonusům",
                    "Funguje na iOS i Android",
                  ].map(item => (
                    <div key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Payments */}
              <div id="platby-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody v Golden Panda</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Golden Panda podporuje širokou škálu platebních metod.
                </p>

                <div className="grid sm:grid-cols-2 gap-3 mb-5">
                  {[
                    { label: "Minimální vklad",  value: "500 Kč" },
                    { label: "Minimální výběr",  value: "625 Kč" },
                    { label: "Rychlost výplat",  value: "1–3 dny; krypto okamžitě" },
                    { label: "Poplatky",         value: "Žádné za vklady ani výběry" },
                  ].map(({ label, value }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-900 font-bold text-sm">{value}</div>
                    </div>
                  ))}
                </div>

                <div className="space-y-3 mb-5">
                  {[
                    { cat: "Bankovní karty:", methods: "Visa, Mastercard" },
                    { cat: "Elektronické peněženky:", methods: "Google Pay, Apple Pay" },
                    { cat: "Kryptoměny:", methods: "Bitcoin, Ethereum, Litecoin, Tether a další" },
                    { cat: "Bankovní převody:", methods: "Standardní bankovní převod" },
                  ].map(({ cat, methods }) => (
                    <div key={cat} className="flex items-start gap-2 text-sm">
                      <span className="text-gray-600 font-semibold flex-shrink-0">{cat}</span>
                      <span className="text-gray-500">{methods}</span>
                    </div>
                  ))}
                </div>

                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Platební metody</div>
                  <div className="flex flex-wrap gap-1.5">
                    {visiblePayments.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {paymentMethods.length > 6 && (
                      <button onClick={() => setShowAllPayments(!showAllPayments)} className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline">
                        {showAllPayments ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{paymentMethods.length - 6} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Jak vložit peníze</div>
                  <ol className="space-y-1.5 text-gray-600 text-sm list-none">
                    {[
                      "Přihlaste se do účtu. Použijte své aktuální přihlašovací údaje.",
                      "Jděte do sekce. Přejděte do sekce \u201ePokladna\u201c.",
                      "Vyberte metodu. Zvolte si, jak chcete platit.",
                      "Zadejte částku. Napište, kolik chcete vložit, a potvrďte transakci.",
                    ].map((step, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                      </li>
                    ))}
                  </ol>
                  <p className="text-gray-400 text-xs mt-2">Peníze se vám připíší okamžitě, takže můžete rovnou začít hrát!</p>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Jak vybrat peníze</div>
                  <ol className="space-y-1.5 text-gray-600 text-sm list-none">
                    {[
                      "Jděte na web. Přejděte do sekce \u201ePokladna\u201c na stránkách kasina.",
                      "Vyberte možnost. Zvolte \u201eVýběr prostředků\u201c.",
                      "Uveďte částku. Napište, kolik a jakou metodou chcete vybrat.",
                      "Potvrďte operaci. Potvrďte svůj požadavek a pak už jen čekejte na zpracování.",
                    ].map((step, i) => (
                      <li key={i} className="flex items-start gap-2">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {step}
                      </li>
                    ))}
                  </ol>
                  <p className="text-gray-400 text-xs mt-2">Výběr obvykle trvá od několika hodin do pár dnů. Vše záleží na tom, jakou platební metodu jste si vybrali.</p>
                </div>
              </div>

              {/* Support */}
              <div id="podpora-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora Golden Panda</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Kdyby se cokoliv stalo nebo byste měli otázky, zákaznická podpora Golden Panda je vždy připravena pomoci. Mají kvalifikovaný personál, který vám rád pomůže s čímkoliv. Podpora funguje rychle a efektivně, aby se hráči z celého světa cítili komfortně a bezpečně.
                </p>
                <div className="grid sm:grid-cols-3 gap-3 mb-4">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Online chat</div>
                      <div className="text-green-600 text-xs">Odpověď do pár minut</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">Odpověď do 24 hodin</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-[#f3f6fb] border border-[#dde4ee] rounded-xl">
                    <Clock className="w-5 h-5 text-[#003da5] mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Dostupnost</div>
                      <div className="text-[#003da5] text-xs">24/7</div>
                    </div>
                  </div>
                </div>
                <p className="text-gray-500 text-sm">
                  Jazyky podpory: angličtina, španělština, němčina a další.
                </p>
              </div>

              {/* Safety */}
              <div id="zodpovedne-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost a férovost</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Golden Panda používá SSL šifrování pro ochranu vašich dat. Všechny hry jsou certifikované a pravidelně se kontrolují na férovost. Platforma navíc nabízí různé nástroje pro zodpovědné hraní:
                </p>
                <div className="space-y-2">
                  {[
                    ["Sebeomezení", "Můžete si nastavit limity na vklady, prohry a čas, který strávíte hraním."],
                    ["Sebevyloučení", "Možnost dočasně nebo trvale zablokovat účet na vlastní žádost."],
                    ["Ověření věku", "Povinné ověření identity, aby se zabránilo hraní nezletilých."],
                    ["Transparentní zásady ochrany soukromí", "Veškeré informace o sběru a zpracování dat jsou volně dostupné."],
                  ].map(([title, desc]) => (
                    <div key={title} className="flex items-start gap-3 py-2 border-b border-[#eef1f7] last:border-0">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <div>
                        <span className="font-semibold text-gray-900 text-sm">{title}: </span>
                        <span className="text-gray-500 text-sm">{desc}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <p className="text-gray-500 text-sm mt-3 italic">
                  Golden Panda dodržuje mezinárodní bezpečnostní standardy, aby se uživatelé cítili opravdu v bezpečí.
                </p>
              </div>

              {/* Summary */}
              <div id="verdikt" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Shrnutí</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Golden Panda je moderní online kasino, které vás vážně dostane. Nabízí obrovskou spoustu her – přes 3 000 kousků, ze kterých si vybere každý! Navíc vás přivítá parádním bonusem a pravidelně dostanete cashback, aniž byste cokoli museli protáčet. A co je super, můžete tu platit kryptoměnami a výhry dostanete bleskurychle. Samozřejmostí je, že vše skvěle šlape i na mobilu.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Celkově vzato, Golden Panda nabízí opravdu silnou výbavu. Tohle kasino je rozhodně nad průměrem oproti jiným platformám. S ohledem na všechno, co nabízí, hodnotíme Golden Panda 8 z 10 a doporučujeme ho každému, kdo ocení prvotřídní servis.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full bg-[#003da5] flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">MR</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo10} alt="Logo Golden Panda" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Golden Panda</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <Star className="w-3 h-3 fill-[#f5c518]/25 text-[#f5c518]" />
                        <span className="text-gray-600 text-xs ml-1">8.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 125 000 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 50 Freespiny</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 30× (nižší než standard!)</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,   label: "Rok",             value: "2024" },
                      { icon: Lock,       label: "Licence",         value: "Curacao OGL/2024" },
                      { icon: Users,      label: "Provozovatel",    value: "Simba N.V." },
                      { icon: Gamepad2,   label: "Počet her",       value: "5 000+" },
                      { icon: CreditCard, label: "Min. vklad",      value: "500 Kč" },
                      { icon: Zap,        label: "Rychlost výplat", value: "1–3 dny (krypto ihned)" },
                      { icon: Clock,      label: "Podpora",         value: "24/7 chat & e-mail" },
                      { icon: Trophy,     label: "Cashback",        value: "10% týdně (bez wageru)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="golden-panda" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/fastslots" className="text-[#003da5] hover:underline" data-testid="review-link-fast-slots">Fast Slots</a>
              {" · "}
              <a href="/kasina/instant-casino" className="text-[#003da5] hover:underline" data-testid="review-link-instant-casino">Instant Casino</a>
              {" · "}
              <a href="/kasina/onlyspins" className="text-[#003da5] hover:underline" data-testid="review-link-onlyspins">OnlySpins</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
